// source: api/soter-task/dashboard/v1/assessmet_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var api_soter$task_common_v1_assessment_message_pb = require('../../../../api/soter-task/common/v1/assessment_message_pb.js');
goog.object.extend(proto, api_soter$task_common_v1_assessment_message_pb);
